module.exports = __webpack_public_path__ + "static/media/register_card.648afd76.svg";